
import { React, useState, useEffect } from "react";
import "./index.css";
import ApprovalTable from "../ApprovalAdmin/ApprovalPage";
import images from "./img/Asset-tracker.png";
import usbimages from "./img/usb-logo.png";
import tsimages from "./img/timebg.png";
import image1 from "./img/login-page.jpg";
import logoutimg from "./img/logout.png";
import image from "./img/switch.png";
import eolimages from "./img/EOL.png";
import pjdimages from "./img/projectdash.png";
import reporticon from "./img/report_img.png";
import onlineimages from "./img/online-logo.png";
import econnectimages from "./img/leymobile-logo.png";
import clmimages from "./img/my-contract.png";
import Tableau from "../Tableau/index";
import swimages from "./img/swImg.jpg";
import vpnimages from "./img/VPN-new.png";
import Anchor from "./img/anchor-logo.png";
import ion from "./img/ion_logo.png";
import tmimg from "./img/switch-data.jpg";
import itpolicyimages from "./img/itpolicy.png";
import flexif from "./img/flexii.png";
import nocimage from "./img/nocimage.png";
import uploadimg from "./img/uploading-docs.jpg";
import switchOnimg from "../../assets/images/switch_on_icon.png";
import empexit from "./img/exit_emp.png";
import pprimage from "./img/PPR_process.png";
import switchgear from "./img/switch_gear.jpg";
import SwipexImage from "../../assets/images/SWIPEX_2.0_Transparent.png"
import { useNavigate } from "react-router-dom";

import axios from "axios";

import { GET_REPORTING_MANAGER } from "../AppConstant";

export default function LandingPageDashboard() {
  const navigate = useNavigate();

  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const data = [
    "300371",
    "300532",
    "300539",
    "300226",
    "300553",
    "300003",
    "300169",
    "300561",
    "300136",
    "300365",
    "300310",
    "300381",
    "300114",
    "300124",
    "300449",
    "300370",
    "300111",
    "300430",
    "300448",
    "300115",
    "300034",
    "300549",
    "300684",
    "300583",
    "300234",
    "300306",
  ];
  useEffect(() => {
    getsession();
    getreportingmanager();
  }, []);

  const [isallowed, setisallowed] = useState(false);

  const getreportingmanager = async() => {
    try {
      const empid = localStorage.getItem("empid");

      const res = await axios.get(GET_REPORTING_MANAGER, {
        params: { empid }
      });

      const rmemail = res.data.rmemail;
      const location = res.data.location;

      localStorage.setItem('rmemail', rmemail);
      localStorage.setItem('location', location);

      if (location === "arihant" || location === "corporate") {
        setisallowed(true);
      } else {
        setisallowed(false);
      }

    } catch (err) {
      console.error(err);
    }
  }


  const getsession = () => {
    if (localStorage.getItem("sessions") !== "isactive") {
      window.location.href = "/";
    }
  };
  const onLeaveTab = () => {
    window.location.href = "/LeaveRequest";
  };
  const assetrequest = () => {
    if (
      localStorage.getItem("dept") === "IT" ||
      localStorage.getItem("dept") === "HR & Admin"
    ) {
      window.location.href = "/vendormaster";
    }
  };
  const nocclearance = () => {
    window.location.href = "/noc";
  }
  const vendormaster = () => {
    window.location.href = "/timetracker";
  };

  const ITaccessories = () => {
    localStorage.setItem('AllowSwitchGear', "Allow"); 
    navigate("/ITaccessories");
  };

   const SwipeX = () => {
    navigate("/swipex");
  };

  const switchOn = () => {
    window.location.href = "/switchon";
  };

  const redirectToLogin = () => {
    window.location.href = "/login";
  };
  const redirectMyContract = () => {
    window.open("https://clm.switchmobilityev.com/", "_blank");
    // window.location.href = "https://clm.switchmobilityev.com/"
  };
  const redirectOnlineapproval = () => {
    window.open("https://onlineapproval.switchmobilityev.com/", "_blank");
    // window.location.href = "https://onlineapproval.switchmobilityev.com/ "
  };
  const projectdashboard = () => {
    window.open("https://projectdashboard.switchmobilityev.com/", "_blank");
    // window.location.href = "https://onlineapproval.switchmobilityev.com/ "
  };
  const leymobile = () => {
    window.open("https://econnect.ashokleyland.com/login.jsp", "_blank");
    // window.location.href = "https://onlineapproval.switchmobilityev.com/ "
  };

  const redirectusercreation = () => {
    window.location.href = "/registration";
  };
  const redirectusbactivation = () => {
    window.location.href = "/request_activate";
  };
  const softwareRqFn = () => {
    window.location.href = "/software_access";
  };
  const vpnRqFn = () => {
    window.location.href = "/vpn_access";
  };
  const eolfun = () => {
    var listdata = localStorage.getItem("empid");
    if (listdata === "300223" || listdata === "300381") {
      window.location.href = "/EOL";
    }
  };

  const tableau = () => {
    if (data.includes(localStorage.getItem("empid"))) {
      window.location.href = "/powerreport";
    }
  };
  const thermald = () => {




    var listdata = localStorage.getItem("empid");
    if (
      listdata === "300645" ||
      listdata === "300381" ||
      listdata === "300169" ||
      listdata === "300348" ||
      listdata === "300391" ||
      listdata === "300608" ||
      listdata === "300316" ||
      listdata === "300182" ||
      listdata === "300596" ||
      listdata === "300651" ||
      listdata === "300514" ||
      listdata === "300668" ||
      listdata === "300316" ||
      listdata === "300182" ||
      listdata === "300044" ||
      listdata === "300003" ||
      listdata === "300558" ||
      listdata === "300407" ||
      listdata === "300392" ||
      listdata === "300585" ||
      listdata === "300588" ||
      listdata === "300733" ||
      listdata === "300155" ||
      listdata === "300539" ||
      listdata === "300551" ||
      listdata === "300487" ||
      listdata === "300306" ||
      listdata === "300561" ||
      listdata === "300402" ||
      listdata === "300916" ||
      listdata === "300653" ||
      listdata === "300849" ||
      listdata === "HLF_0015"

    ) {
      window.location.href = "/PD";
    }
  };
  const darwinfn = () => {
    window.open("https://ashokleyland.darwinbox.in/user/login", "_blank");
  };
  const switchionfn = () => {
    window.open("https://ion.switchmobilityev.com/", "_blank");
  };

  const redirectitpolicy = () => {
    window.open(
      "https://optaregroup.sharepoint.com/sites/Switch-ITPolicies/_layouts/15/guestaccess.aspx?share=EiOb3VAivdlKms1ffb_MuIYBWPOwD0FM0Aow5Vp5NnCLmA&email=Vignesh.b%40Switchmobilityev.com&e=L8x9hI",
      "_blank"
    );
  };

  const uploaddocs = () => {
    window.location.href = "/userdata";
  };
  const ppr = () => {
    window.location.href = "/ppr";
  }
  const emplexit = () => {
    window.location.href = "/userprofile";
  };
  return (
    <>
      {/* <div className="landing-parent" style={{backgroundImage:`linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)),url(${image1})`,backgroundRepeat:"no-repeat"}}> style={{backgroundImage:`linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5))`,backgroundColor:"cadetblue",backgroundRepeat:"no-repeat"}}*/}
      <div className="">
        {/* <Tableau/> */}
        <div className="switch_new">
          <img className="switch-img-new" src={image} />
          <img
            className="logout-img-new"
            title="Logout"
            onClick={redirectToLogin}
            src={logoutimg}
          />
        </div>
        <br />
        <br />

        <div className="container ">


          <div className="row">


   <div className="col-md-2">
              <div className="single-menu-item">
                <div className="module-icon-wrapper cursordesign" onClick={SwipeX}>
                  <div className="badge-icon">New</div>

                  <img className="img-design" style={{ objectFit: "fill" }} src={SwipexImage} alt="Switch GEAR" />
                </div>
                <p>SwipeX-2.0</p>
              </div>
            </div>

            {isallowed &&
            
              <div className="col-md-2">
              <div className="single-menu-item">
                <div className="module-icon-wrapper cursordesign" onClick={ITaccessories}>
                  <img className="img-design" style={{ objectFit: "fill" }} src={switchgear} alt="Switch GEAR" />
                </div>
                <p>Switch GEAR</p>
              </div>
            </div>

            }

          


            <div className="col-md-2">
              <div className="single-menu-item">
                <div className="module-icon-wrapper cursordesign" onClick={switchOn}>

                  <img className="img-design" src={switchOnimg} alt="Switch On" />
                </div>
                <p>Switch On</p>
              </div>
            </div>
            <div className="col-md-2 ">
              <div class="single-menu-item ">
                <div
                  class="module-icon-wrapper cursordesign"
                  onClick={vendormaster}
                >
                  <img className="img-design" src={tsimages} />
                </div>
                <p>Time Tracker</p>
              </div>
            </div>

            {localStorage.getItem("type") === "Offrole" ? (
              <div className="col-md-2 ">
                <div class="single-menu-item ">
                  <div
                    class="module-icon-wrapper cursordesign"
                    onClick={uploaddocs}
                  >
                    <img className="img-design" src={uploadimg} />
                  </div>
                  <p>Document Upload</p>
                </div>
              </div>

            ) : (
              ""
            )}
            {localStorage.getItem("type") === "Offrole" ? (
              <div className="col-md-2 ">
                <div class="single-menu-item ">
                  <div
                    class="module-icon-wrapper cursordesign"
                    onClick={emplexit}
                  >
                    <img className="img-design-exit" src={empexit} />
                  </div>
                  <p>Employee Exit</p>
                </div>
              </div>

            ) : (
              ""
            )}
            {localStorage.getItem("type") !== "Offrole" ? (
              <>
                <div className="col-md-2 ">
                  <div class="single-menu-item ">
                    <div
                      class="module-icon-wrapper cursordesign"
                      onClick={redirectusbactivation}
                    >
                      <img className="img-design" src={usbimages} />
                    </div>
                    <p>Access Request</p>
                  </div>
                </div>
                {/* <div className="col-md-2 ">
                <div class="single-menu-item " >
                <div class="module-icon-wrapper cursordesign"  onClick={vpnRqFn}>
                <img className="img-design-vpn"  src={vpnimages}/>
                </div>
                <p>VPN Access</p>
                </div>
                </div> */}
                {/* <div className="col-md-2 " >
                <div class="single-menu-item " >
                <div class="module-icon-wrapper cursordesign" onClick={softwareRqFn}>
                <img className="img-design-soft"  src={swimages}/>
                </div>
                <p>Software Access</p>
                </div>
                </div> */}
                <div className="col-md-2">
                  <div class="single-menu-item ">
                    <div
                      class="module-icon-wrapper cursordesign"
                      onClick={tableau}
                    >
                      <img className="img-design" src={reporticon} />
                    </div>
                    <p>Vehicle Analystics Report</p>
                  </div>
                </div>
                {/* <div className="col-md-2" >
                <div class="single-menu-item " >
                <div class="module-icon-wrapper cursordesign" onClick={assetrequest}>
                <img className="img-design-asset"  src={images}/>
                </div>
                <p>Asset Master</p>
                </div>
                </div>*/}
                <div className="col-md-2">
                  <div class="single-menu-item ">
                    <div
                      class="module-icon-wrapper cursordesign"
                      onClick={assetrequest}
                    >
                      <img className="img-design-asset" src={flexif} />
                    </div>
                    <p>FlexiForce</p>
                  </div>
                </div>
                
                
                <div className="col-md-2">
                  <div class="single-menu-item ">
                    <div
                      class="module-icon-wrapper cursordesign"
                      onClick={nocclearance}
                    >
                      <img className="img-design-asset" src={nocimage} />
                    </div>
                    <p>NOC Clearance</p>
                  </div>
                </div>


              </>
            ) : (
              ""
            )}

          {localStorage.getItem("type") !== "Offrole" || localStorage.getItem("empid") == "HLF_0015" ? (
            <>
             
                <div className="col-md-2 ">
                  <div class="single-menu-item ">
                    <div
                      class="module-icon-wrapper cursordesign"
                      onClick={thermald}
                    >
                      <img className="img-design-termal" src={tmimg} />
                    </div>
                    <p>Switch Data</p>
                  </div>
                </div>
                <div className="col-md-2 ">
                  <div class="single-menu-item ">
                    <div
                      class="module-icon-wrapper cursordesign"
                      onClick={darwinfn}
                    >
                      <img className="img-design" src={Anchor} />
                    </div>
                    <p>Anchor</p>
                  </div>
                </div>
                <div className="col-md-2 ">
                  <div class="single-menu-item ">
                    <div
                      class="module-icon-wrapper cursordesign"
                      onClick={switchionfn}
                    >
                      <img className="img-design-ion" src={ion} />
                    </div>
                    <p>switch iON</p>
                  </div>
                </div>
                <div className="col-md-2 ">
                  <div class="single-menu-item ">
                    <div
                      class="module-icon-wrapper cursordesign"
                      onClick={redirectOnlineapproval}
                    >
                      <img className="img-design-online" src={onlineimages} />
                    </div>
                    <p>Online Approval</p>
                  </div>
                </div>
                <div className="col-md-2 ">
                  <div class="single-menu-item ">
                    <div
                      class="module-icon-wrapper cursordesign"
                      onClick={leymobile}
                    >
                      <img className="img-design-econ" src={econnectimages} />
                    </div>
                    <p>LeyMobile</p>
                  </div>
                </div>
                <div className="col-md-2 ">
                  <div class="single-menu-item ">
                    <div
                      class="module-icon-wrapper cursordesign"
                      onClick={redirectMyContract}
                    >
                      <img className="img-design-contract" src={clmimages} />
                    </div>
                    <p>My Contracts</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div class="single-menu-item">
                    <div
                      class="module-icon-wrapper cursordesign"
                      onClick={redirectitpolicy}
                    >
                      <img
                        className="img-design-contract"
                        src={itpolicyimages}
                      />
                    </div>
                    <p>IT Policies</p>
                  </div>
                </div>

                <div className="col-md-2 ">
                  <div class="single-menu-item ">
                    <div
                      class="module-icon-wrapper cursordesign"
                      onClick={eolfun}
                    >
                      <img className="img-design" src={eolimages} />
                    </div>
                    <p>EOL</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div class="single-menu-item ">
                    <div
                      class="module-icon-wrapper cursordesign"
                      onClick={ppr}
                    >
                      <img className="img-design-asset" src={pprimage} />
                    </div>
                    <p>PPR</p>
                  </div>
                </div>


            </>
          ) : (
            ""
          )}

           </div>


          {localStorage.getItem("type") !== "Offrole" ? (
            <div className="row ">
              <div className="col-md-8 text-design-note">
                {" "}
                Note: EOL, Asset Master and Vehicle Analysis Report screen will
                only be accessible to specific departments.
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      {/* <div className="approval-landing">
                <div className="approval-heading">   
                    <span>Approve Leave Request</span>
                    <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
                </div><br/>
                <ApprovalTable/>
            </div> */}
    </>
  );
}
